/**
 * Single source of truth for channel/category Iconify icon strings.
 *
 * Rule: any component that displays a channel name alongside an icon MUST
 * import from here. Never hardcode a channel icon string inline.
 *
 * To change a channel icon app-wide: edit one value here.
 */
export const CHANNEL_ICONS = {
  // --- Marketing channels ---
  email:             'fluent:mail-unread-20-regular',
  directMail:        'fluent:mail-48-regular',
  digitalAds:        'streamline-ultimate:shopping-broadcast-advertising-monitor-megaphone',
  eddm:              'pepicons-pencil:map',
  qrCode:            'material-symbols:qr-code',
  informedDelivery:  'mdi:email-open-multiple-outline',
  sms:               'solar:chat-round-dots-bold',
  webRetargeting:    'mdi:web',
  rcs:               'solar:chat-square-call-bold',
  webPersonalization: 'solar:widget-4-bold',

  // --- Voice ---
  voice:             'solar:phone-calling-linear',
  voiceCampaigns:    'solar:clapperboard-edit-linear',
  voiceWorkflows:    'material-symbols:auto-transmission-outline',
  voiceAgents:       'material-symbols:smart-toy-outline',

  // --- Dashboard / navigation ---
  overview:          'material-symbols:team-dashboard-outline',
  analytics:         'solar:presentation-graph-linear',
  attribution:       'solar:graph-linear',

  // --- Wallet usage categories ---
  audience:          'solar:users-group-rounded-bold',
  lookalike:         'solar:user-check-bold',
  predictions:       'solar:chart-2-bold',
  dataPurchase:      'solar:database-bold',
  recharge:          'solar:wallet-money-bold',
  emailVerification: 'solar:shield-check-bold',
  agentic:           'solar:chat-round-dots-bold',
  journeyBuilder:    'solar:route-bold',
  moduleAddon:       'solar:widget-add-bold',
  categoryDefault:   'solar:layers-bold',
} as const;

export type ChannelIconKey = keyof typeof CHANNEL_ICONS;
